let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jIOao")).then(() => parcelRequire('2pLZi'));